import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ReturnArrowSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.30827 12.3343L4.1416 8.16764L8.30827 4.00098'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.4749 17.3346V11.5013C17.4749 10.6172 17.1237 9.7694 16.4986 9.14428C15.8735 8.51916 15.0257 8.16797 14.1416 8.16797H4.1416'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ReturnArrowIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ReturnArrowSvg} {...props} />
);
